
export const useMobileOS = () => {

    const getMobileOperatingSystem = () => {
        var userAgent = navigator.userAgent || navigator.vendor;
        if (
            userAgent.match(/iPad/i) ||
            userAgent.match(/iPhone/i) ||
            userAgent.match(/iPod/i)
        ) {
            return "iOS";
        } else if (userAgent.match(/Android/i)) {
            return "Android";
        } else if (userAgent.match(/Windows/i)) {
            return "Windows";
        }
        return "unknown";
    };

    return {
        getMobileOperatingSystem,
    };
};
